module.exports = __webpack_public_path__ + "img/1.879c625d.jpg";